/**
 * Configuração simplificada do AWS Cognito
 * Usa apenas REACT_APP_BASE_URL como variável de ambiente opcional
 */

/**
 * Obtém a URL base da aplicação
 * Usa REACT_APP_BASE_URL se definido, senão detecta automaticamente
 */
const getBaseUrl = () => {
  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL;
  }
  
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  return 'http://localhost:3000';
};

/**
 * Configuração do OIDC para react-oidc-context
 */
export const getOidcConfig = () => {
  const cognitoIssuer = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const baseUrl = getBaseUrl();

  if (!cognitoIssuer || !clientId) {
    throw new Error(
      'REACT_APP_COGNITO_DOMAIN e REACT_APP_COGNITO_CLIENT_ID devem estar configurados'
    );
  }

  return {
    authority: cognitoIssuer,
    client_id: clientId,
    redirect_uri: baseUrl,
    post_logout_redirect_uri: `${baseUrl}/log_in`,
    response_type: 'code',
    scope: 'email openid phone',
    automaticSilentRenew: true,
    silent_redirect_uri: `${baseUrl}/silent-renew.html`,
    loadUserInfo: true,
    extraQueryParams: { 
      lang: "pt-BR"
    }
  };
};

/**
 * Obtém a URL completa de logout do Cognito
 */
export const getCognitoLogoutUrl = () => {
  const cognitoHostedDomain = process.env.REACT_APP_COGNITO_HOSTED_DOMAIN;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const baseUrl = getBaseUrl();

  if (!cognitoHostedDomain || !clientId) {
    throw new Error('Configuração do Cognito não encontrada');
  }

  return `${cognitoHostedDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(`${baseUrl}/log_in`)}`;
};
